<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Users</li>
    </ol>
  </nav>

  <div class="row align-items-center">
    <div class="col mt-md-0 mb-2 text-right float-right" style="height:26px;">
      <!-- <button routerLink="/admin/roleList" class="btn ml-2 btn-outline-primary btn-sm">
   Roles</button>-->
      <!--
                  <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
      --> <a placement="bottom" ngbTooltip="Create" class="ml-3" id="User">
      <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/adminUserCreate" width="30" height="30"
           viewBox="0 0 30 30">
        <defs>
          <style>.a{fill:#8a55bb;}.b{fill:#fff;}</style>
        </defs>
        <g transform="translate(4 2.5)">
          <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
          <path class="b"
                d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                transform="translate(2.823 3.938)"/>
        </g>
      </svg>
    </a>
      <!--<button routerLink="/admin/adminUserCreate" class="btn ml-2 btn-outline-primary btn-sm">
  <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
    <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
  </svg>Create</button>-->
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">

        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <!--                <th ><div class="form-checkbox">
              <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()"/>
              <label for="all_items"></label>
            </div></th>-->
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email Address</th>
            <th>Phone</th>
            <th>Role</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let t of userList">
            <!-- <td><div class="form-checkbox">
<input type="checkbox" id="{{ao.id}}" [(ngModel)]="ao.isSelected" name="list_name" (change)="selectAOwner(ao)">
<label for="{{ao.id}}"></label></div></td>-->
            <td style="text-transform:capitalize;"><a class="" routerLink="/admin/viewUser/{{t.id}}">{{t.firstName}}</a></td>
            <td style="text-transform:capitalize;">{{t.lastName}}</td>
            <td>{{t.email}}</td>
            <td>{{t.mobile}}</td>
            <td>{{t.userRole | replaceStatus}}</td>

            <td>
              <div class="toggle-2">
                <input type="checkbox" name="onoffswitch" id="customSwitch1_{{t.id}}" class="custom-control-input"
                       (click)="changeStatus(t)" [checked]="t.status==='ACTIVE'" class="checkbox"/>
                <label for="customSwitch1_{{t.id}}" class="toggle">
                  <span>ON</span><span>OFF</span>
                </label>
              </div>
              <!--
<div class="custom-control custom-switch">
<input type="checkbox"  class="custom-control-input" (click)="changeStatus(t)" id="customSwitch_{{t.toteId}}" [checked]="t.status==='ACTIVE'">
<label class="custom-control-label" for="customSwitch_{{t.toteId}}"> </label>
</div>
-->
            </td>

          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="userList?.length===0|| !userList?.length">
            <td colspan="6" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>


      </div>
      <div class="inner-box d-block d-sm-none">

        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <!--                <th ><div class="form-checkbox">
              <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()"/>
              <label for="all_items"></label>
            </div></th>-->
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email Address</th>
            <th>Phone</th>
            <th>Role</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let t of userList">
            <!-- <td><div class="form-checkbox">
<input type="checkbox" id="{{ao.id}}" [(ngModel)]="ao.isSelected" name="list_name" (change)="selectAOwner(ao)">
<label for="{{ao.id}}"></label></div></td>-->
            <td><b class=" tablesaw-cell-label">First Name</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{t.firstName}}</span></td>
            <td><b class=" tablesaw-cell-label">Last Name</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{t.lastName}}</span></td>
            <td><b class=" tablesaw-cell-label">Email Address</b>
              <span class="tablesaw-cell-content">{{t.email}}</span></td>
            <td><b class=" tablesaw-cell-label">Phone</b>
              <span class="tablesaw-cell-content">{{t.mobile}}</span></td>
            <td><b class=" tablesaw-cell-label">Role</b>
              <span class="tablesaw-cell-content">{{t.userRole | replaceStatus}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" (click)="changeStatus(t)"
                       id="customSwitch_{{t.toteId}}" [checked]="t.status==='ACTIVE'">
                <label class="custom-control-label" for="customSwitch_{{t.toteId}}"> </label>
              </div>
              </span></td>

          </tr>
          </tbody>
        </table>


      </div>

    </div>
  </div>
</section>
